var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"light-control-container"},[(_vm.args.type == 'common')?_c('MenuCommon',{staticClass:"light-control-menu",on:{"cmd":_vm.cmdGot}}):_vm._e(),_c('ListCommon',{ref:"lightList1",staticClass:"light-control-list",attrs:{"type":_vm.args.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }